<template>
  <div class="container">

    <div class="topImage"></div>

    <div class="theme">
      <div class="navigation">
        <div class="selector">
          <div :class="albumName == '招标公告' ? 'option' : 'optionActive'" @click="changeAlbum('招标公告')">招标公告</div>
          <div :class="albumName == '结果公告' ? 'option' : 'optionActive'" @click="changeAlbum('结果公告')">结果公告</div>
          <div :class="albumName == '预中标公告' ? 'option' : 'optionActive'" @click="changeAlbum('预中标公告')">预中标公告</div>
          <div :class="albumName == '更正公告' ? 'option' : 'optionActive'" @click="changeAlbum('更正公告')">更正公告</div>
          <div :class="albumName == '需求调查' ? 'option' : 'optionActive'" @click="changeAlbum('需求调查')">需求调查</div>
          <div :class="albumName == '公司通知' ? 'option' : 'optionActive'" @click="changeAlbum('公司通知')">公司通知</div>
        </div>
        <div @click="selectAlbum('album',albumName)" class="more">更多+</div>
      </div>
      <div class="theme-wrap" v-loading="loading">
        <div class="item" @click="select(item.postsId)" v-for="(item,index) in postsList.slice(0,10)" :key="index" >
          <div class="item-title">{{item.postsTitle}}</div>
          <div class="item-time">{{item.postsTime.substring(0,10)}}</div>
        </div>
      </div>
    </div>

    <div class="aboutUs">
      <!-- <div class="title">关于我们</div>
      <div class="minTitle">ABOUT US</div> -->
      
      <div style="padding:100px 190px 100px 190px;">

        <div style="margin:0px auto;max-width:1520px;display:flex;color:#7f7f7f;">
          <div class="companyImage"></div>
          
          <div style="margin-left:30px;width:50%;">
            <div style="font-size:26px;font-weight:500;color:#0058a4;margin-bottom:20px">广东经纬招标代理有限公司</div>
            <p>广东经纬招标代理有限公司(以下简称“广东经纬”)是经广州市越秀区市场监督管理局批准设立， 是一家依法从事招标采购代理并提供相关服务的专业机构。广东经纬现可承接工程、货物、服务招标采 购业务， 业务范围包括:政府采购招标代理、工程招标代理、国有企业采购招标代理、采购专业咨询、 项目实施方案策划、项目管理咨询等业务。</p>
            <p>广东经纬拥有一支以专业技术人员为主体的高素质人才队伍，涵盖了工商管理、金融管理、法律、工程预算、计算机、信息系统等专业领域。通过团队成员在招标代理工作实践中，积累了丰富的项目经验，储备了充足的专业知识，能够胜任各类复杂项目的立项论证、招标采购代理、履约管理等工作。</p>
            <p>公司办公面积 630 平方米，拥有现代化办公场地及设施，设立有办公室、开评标室、会客室、财务 室、监控室等。</p>
            <p>公司制订了各种规范的内部管理制度，实行规范化、科学化管理，并相继成为广东省招标投标协会、 中国招标投标协会和广东省政府采购协会的会员单位。</p>
          </div>
        </div>
        

      </div>

    </div>

    <div class="cooperation">
      <div style="max-width:1520px;margin:0px auto;display:flex;justify-content:space-around;">
        <a href="http://gzg2b.gzfinance.gov.cn" target="_blank">
          <img src="../../public/img/cooperation1.png" alt="">
        </a>

        <a href="http://www.ccgp.gov.cn" target="_blank">
          <img src="../../public/img/cooperation2.png" alt="">
        </a>

        <a href="https://gdgpo.czt.gd.gov.cn" target="_blank">
          <img src="../../public/img/cooperation3.png" alt="">
        </a>

        <a href="http://www.chinabidding.com.cn" target="_blank">
          <img src="../../public/img/cooperation4.png" alt="">
        </a>

        <a href="https://www.chinabidding.com" target="_blank">
          <img src="../../public/img/cooperation5.png" alt="">
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "Home",
  data(){
	  return{
      loading:true,

      pageNum:1,
      categoryName:"公告中心",
      albumName:"招标公告",
      searchContent:"",

      postsList:[],

	  }
  },
  mounted() {
    //this.getHomeThemePosts(this.albumName)
    this.getPostsList()
  },
  methods:{
    // getHomeThemePosts(albumName){
    //   this.albumName = albumName
    //   this.loading = true
    //   var url = this.GLOBAL.URL+"/getThemePosts/album/"+albumName+"/1"
    //   axios.get(url).then((response) => {
    //     console.log(response.data)
    //     this.postsList = response.data.typePosts.list
    //     this.loading = false
    //   },(error) => {
    //     console.log(error.message);
    //   });
    // },
    changeAlbum(albumName){
      this.albumName = albumName
      this.getPostsList()
    },
    getPostsList(){
      this.loading = true
      let formData = new FormData();
      formData.append("pageNum", this.pageNum);
      formData.append("categoryName", this.categoryName);
      formData.append("albumName", this.albumName);
      formData.append("searchContent", this.searchContent);
      var url = this.GLOBAL.URL+"/postsList"
      axios.post(url,formData).then((response) => {
        console.log(response.data);
        this.postsList = response.data.list
        this.pageMessage = response.data
        this.loading = false
      });
    },
    select(postsId){  
      this.$router.push({
        path: '/detail',
        query: { 
          postsId: postsId,
        }
      })
    },
    selectAlbum(type,albumName){
      this.$router.push({
        path: '/theme',
        query: { 
          type:type,
          themeName: albumName,
        }
      })
    },
  },

};
</script>

<style scoped>
.container{
  min-width: 1300px;
  /* max-width:1920px; */
}
.topImage{
  background-image:url('../../public/img/jingwei.png');
  background-repeat:no-repeat;
  background-position:50% 50%;
  background-size:cover;
  height: 350px;
}
.theme{
  /* margin: 50px 200px 50px 200px; */
  max-width: 1520px;
  margin:0px auto;
  padding: 50px 200px 50px 200px;

}
.title{
  text-align: center;
  font-size: 34px;
  color:#0058a4;
  padding-top: 40px;
  position: relative;
}
.minTitle{
  text-align: center;
  font-size: 18px;
  color:#6d6d6d;
  position: relative;
}

.navigation{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.15);
  margin-bottom: 15px;
  overflow: hidden;
}
.selector{
  display: flex;
}
.option{
  display: flex;
  align-items: center;
  background-color: #0058a4;
  color: #fff;
  border-radius: 20px;
  padding: 12px 22px 12px 22px;
  margin-right: 10px;
  cursor: pointer;
  font-size: 18px;
}
.optionActive{
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #0058a4;
  padding: 12px 22px 12px 22px;
  margin-right: 10px;
  cursor: pointer;
  font-size: 18px;
}
.more{
  margin-right: 20px;
  color: #0058a4;
  cursor: pointer;
}
.theme-wrap{
  padding: 10px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.15);
  min-height: 45px;
}
.item{
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 10px 20px;
  cursor: pointer;
  border-radius: 20px;
  color: #6d6d6d;

}
.item-title{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}
.item-time{
  white-space: nowrap;
}
.item:hover{
  background-color: #f2f2f2;
}

.downloadWrap{
  padding: 30px 0px 0px 0px;
}
.downloadFile{
  height: 100px;
  background-color: #f2f2f2;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 0px 20px;
  margin: 15px;
  color: #6d6d6d;
  font-size: 20px;
  font-weight: 400;
  white-space: nowrap;
  text-decoration: none;
  user-select: none;
}
.downloadFile a{
  line-height: 0px;
}
.aboutUs{
  background-image:url('../../public/img/bg.png');
  background-repeat:no-repeat;
  background-position:50% 50%;
  background-size:cover;
  /* height: 650px; */

  
}
.companyImage{
  background-image:url('../../public/img/company1.jpg');
  background-repeat:no-repeat;
  background-position:50% 50%;
  background-size:cover;
  /* height: 420px; */
  width: 50%;
  border-radius: 20px;
  margin-right: 30px;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.15);

}


.regulations{
  padding: 40px 0px 60px 0px;
}
.cooperation{
  padding: 50px 190px 50px 190px;
}
.cooperation img{
  height: 58px;
}

.skip{
  display: flex;
  justify-content: center;
  margin-top:20px;
}
.skip div{
  display: flex;
  align-items: center;
  justify-content: center;
  color:#0058a4;
  cursor: pointer;
  /* padding: 10px 20px 10px 20px;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.1);
  border-radius: 15px;
  overflow: hidden; */
}
.skip a{
  display: flex;
  align-items: center;
  justify-content: center;
  color:#0058a4;
  cursor: pointer;
  padding: 10px 0px 0px 0px;
  /* padding: 10px 20px 10px 20px;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.1);
  border-radius: 15px;
  overflow: hidden; */
    
  height: 22.5px;
  line-height: 0px;
  text-decoration: none;
}
</style>